import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectName, selectEmail, selectPhoneNumber, selectShowInvalids } from '@store/order/selectors';
import { setName, setEmail, setPhoneNumber } from '@store/order/slice';
import TextField from '@components/text-field/TextField';
import { invalidFormValue, isValidEmail, isValidPhoneNumber } from '@components/utils';



const CustomerInfo = () => {
	const { t } = useTranslation('forms');

	const name = useSelector(selectName);
	const email = useSelector(selectEmail);
	const phoneNumber = useSelector(selectPhoneNumber);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateName = (value: string | null) => dispatch(setName(value));
	const updateEmail = (value: string | null) => dispatch(setEmail(value));
	const updatePhoneNumber = (value: string | null) => dispatch(setPhoneNumber(value));

	return (
		<div className='customer-info-section'>

			<div className='customer-text'>
				<h2>{t('customerInfo.sectionLabel')}</h2>
			</div>

			<TextField
				label={t('inputLabels.fullName')}
				required={true}
				value={name ? name : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateName(null) : updateName(value)}
				errorMessage={showInvalids && invalidFormValue(name) ? t('validation.requiredField') : undefined} />

			<TextField
				label={t('inputLabels.email')}
				required={true}
				value={email ? email : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateEmail(null) : updateEmail(value)}
				errorMessage={showInvalids && invalidFormValue(email)
					? t('validation.requiredField')
					: showInvalids && !isValidEmail(email)
					? t('validation.incorrectEmailFormat')
					: undefined} />

			<TextField
				label={t('inputLabels.phone')}
				required={true}
				value={phoneNumber ? phoneNumber : undefined}
				rounded={true}
				maxLength={16}
				onChange={(value: string) =>
					!value && value.length === 0 ? updatePhoneNumber(null) : updatePhoneNumber(value)}
				errorMessage={showInvalids && invalidFormValue(phoneNumber)
					? t('validation.requiredField')
					: showInvalids && !isValidPhoneNumber(phoneNumber)
					? t('validation.incorrectPhoneFormat')
					: undefined} />

		</div>
	);
};

export default CustomerInfo;